const actions = {
  gotFunctionalSkills: 'GOT_FUNCTIONAL_SKILLS',
  startedNewSkillSession: 'STARTED_NEW_SKILL_SESSION',
};

export default actions;
